class TileDialog {
  stateClasses = {
    active: 'tile--active',
  }
  constructor($el, $dialog) {
    this.$el = $el;
    this.$dialog = $dialog;
    this.$close = $dialog.find('[data-tile-dialog="close"]');
    this.dialog = $dialog[0];
    this.isSliding = false;
    this.init();
  }
  
  init = () => {
    this.$el.on('click', this.onTileClick);
    this.$close.on('click', this.close);
    this.$dialog.on('close', this.removeActiveClass);
    this.$dialog.on('click', this.handleBackdropClick); 
  }

  onTileClick = (e) => {
    if (this.isSliding) {
      return;
    }
    this.open();
  }

  open = () => {
    this.$el.addClass(this.stateClasses.active);
    this.dialog.showModal();
  }

  close = () => {
    this.dialog.close();
  }

  removeActiveClass = () => {
    this.$el.removeClass(this.stateClasses.active);
  }

  handleBackdropClick = (e) => {
    if (e.target === this.dialog) {
      this.close();
    }
  }

  destroy = () => {
    this.$el.off('click', this.onTileClick);
    this.$close.off('click', this.close);
    this.$dialog.off('close', this.removeActiveClass);
    this.$dialog.off('click', this.handleBackdropClick);
  }

  setSliding = (isSliding) => {
    this.isSliding = isSliding;
  }
}

export default TileDialog;